import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);
    background: ${colors.white};
    cursor: pointer;
    padding: 16px;
  `,
};

export default styles;
